import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  height: calc(80vh - 164px);
`;

export default Container;
